import { ellipsis, ellipsisMultiline } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		listStyleType: "none",
		...shorthands.padding(0),
		...shorthands.overflow("auto"),
		...shorthands.margin(0),
	},
	itemRoot: {
		display: "flex",
		backgroundColor: tokens.colorNeutralBackground4,
		alignContent: "center",
		alignItems: "center",
		cursor: "pointer",
		// The hover min-height is the row's measured border-box height (see List).
		boxSizing: "border-box",
		...shorthands.overflow("hidden"),
		...shorthands.padding(tokens.spacingHorizontalS),

		":hover": {
			backgroundColor: tokens.colorNeutralBackground4Hover,
		},
		"&:not(:last-of-type)": {
			...shorthands.borderBottom(
				tokens.strokeWidthThin,
				"solid",
				tokens.colorNeutralBackground5
			),
		},
	},
	selectedItem: {
		backgroundColor: tokens.colorNeutralBackground1Hover,
	},
	// A clickable row's text as a native button with no look of its own. It reaches over the row's top
	// and bottom padding, so the row stays clickable there. Its focus ring is an outline: Fluent's focus
	// indicator needs a positioned element, and one in the row would clip the end media's tooltips.
	rowAction: {
		display: "flex",
		flexGrow: 1,
		minWidth: 0,
		...shorthands.margin(`calc(-1 * ${tokens.spacingHorizontalS})`, 0),
		...shorthands.padding(tokens.spacingHorizontalS, 0),
		...shorthands.borderStyle("none"),
		backgroundColor: "transparent",
		color: "inherit",
		fontFamily: "inherit",
		fontSize: "inherit",
		fontWeight: "inherit",
		lineHeight: "inherit",
		textAlign: "left",
		cursor: "inherit",
		outlineStyle: "none",

		":focus-visible": {
			...shorthands.outline(
				tokens.strokeWidthThick,
				"solid",
				tokens.colorStrokeFocus2
			),
			outlineOffset: `calc(-1 * ${tokens.strokeWidthThick})`,
		},
	},
	startMedia: {
		marginRight: tokens.spacingHorizontalS,
		color: tokens.colorNeutralForeground3,
		height: "2rem",
		aspectRatio: 1,
		display: "flex",
		justifyContent: "center",
		alignContent: "center",
		alignItems: "center",
		...shorthands.padding("5px"),
	},
	itemMiddleWrapper: {
		flexGrow: 1,
		...shorthands.overflow("hidden"),
	},
	contentWrapper: {
		...shorthands.overflow("hidden"),
	},
	contentRow: {
		marginTop: "2px",
	},
	textContent: {
		flexGrow: 1,
		flexShrink: 0,
		...ellipsis(),
	},
	// The header becomes a row only when something is rendered beside it, so the plain case keeps the
	// DOM it has always had.
	adornedHeader: {
		minWidth: 0,
	},
	// textContent sizes the header to fill its column, which in a row would push the adornment to the
	// far right and read as a column of its own. Here the header takes only the width it needs and
	// ellipsises once it runs out, so the adornment stays beside the name and always visible.
	adornedHeaderText: {
		flexGrow: 0,
		flexShrink: 1,
	},
	contentText: {
		...ellipsisMultiline(2),
	},
	contentMedia: {
		...shorthands.overflow("hidden"),
		flexShrink: 0,
	},
	// The same gap on its left as the row's padding leaves on its right.
	endMedia: {
		marginLeft: tokens.spacingHorizontalS,
	},
	mainText: {
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.fontSizeBase500,
		letterSpacing: 0,
		textAlign: "left",
	},
	secondaryText: {
		fontSize: tokens.fontSizeBase200,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: "20px",
		letterSpacing: 0,
		textAlign: "left",
	},
	mainTextColor: {
		color: tokens.colorNeutralForeground1,
	},
	secondaryTextColor: {
		color: tokens.colorNeutralForeground3,
	},
});
